import React, { Component } from 'react';
import Axios from 'axios';
import { toast } from 'react-toastify';

/* Config */
import { reactToastifyConfig } from '~/config';

/* Components */
import ProductSearchModelFilter from './ProductSearchModelFilter';
import ProductSearchRadioFilter from './ProductSearchRadioFilter';
import ProductSearchSelectFilter from './ProductSearchSelectFilter';

/* Common */
import { Button } from '~/components/common';

/* Utilities */
import { getFormParams, trans } from '~/utilities';

export default class ProductSearch extends Component {
    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        this.state = {
            filters: [],
            totalResults: 0,
            isLoading: true,
        };

        toast.configure(reactToastifyConfig);
    }

    componentDidMount = () => {
        let params = {};

        if (this.props.brand) {
            params = { 'brand[]': this.props.brand };
        }

        this.fetchData(params);
    }

    fetchData = (initialParams = {}) => {
        this.setState({ isLoading: true, });

        const params = getFormParams(new FormData(this.formRef.current));

        Object.entries(initialParams).forEach(([key, value]) => {
            params.append(key, value);
        });

        Axios.get(this.props.updateUrl, { params }).then((response) => {
            if (response.data) {
                const { filters, count } = response.data;

                this.setState({
                    filters: filters.items,
                    totalResults: count,
                });
            }
        }).catch((error) => {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
            throw new Error(error);
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    };

    updateFilters = (filters) => {
        this.setState({ filters: filters }, () => this.fetchData());
    }

    render() {
        return (
            <form ref={this.formRef} noValidate action={`${this.props.resultsUrl}?${this.formRef.current ? getFormParams(new FormData(this.formRef.current)) : ''}`}>
                <div className="row gutters-3 gutters-xl-4">
                    <ProductSearchRadioFilter
                        filters={this.state.filters}
                        filterKey="sources"
                        updateFilters={this.updateFilters}
                        colClassName="col-12"
                    />
                    <ProductSearchSelectFilter
                        filters={this.state.filters}
                        filterKey="brand"
                        updateFilters={this.updateFilters}
                        colClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    />
                    <ProductSearchModelFilter
                        filters={this.state.filters}
                        updateFilters={this.updateFilters}
                        colClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    />
                    <div className="col-auto col-xxxl-6">
                        <Button
                            className="btn-block mt-3 mt-xl-4"
                            theme="primary"
                            title={trans(`app.content_block.vehicle_search.view_results`, { 'amount': this.state.totalResults })}
                            loading={this.state.isLoading}
                            loadingSize={14}
                            attributes={{ disabled: this.state.isLoading }}
                        />
                    </div>
                </div>
            </form>
        );
    }
}
